module.exports = "<div mat-dialog-content [innerHTML]=\"data.content\"></div>\n"